import { stores } from "../store";

export const appFeatureEnabled = (featureName, contracts = []) => {
      const {configStore} = stores
      let configFeatureEnabled = false
      let  contractFeatureEnabled = false
      const validActiveContracts = contracts.filter(contract => contract.valid && contract.active)
      if(typeof configStore.get(featureName) === "undefined") {
        return false
      }
      if(typeof configStore.get(featureName) === "boolean") {
        configFeatureEnabled = configStore.get(featureName)
      }
      if(typeof configStore.get(featureName) === "string" && (validActiveContracts.some(contract =>
        configStore.get(featureName)?.includes(contract.role)
      ) || !validActiveContracts.length)) {
        configFeatureEnabled = true
      }

      if(!features[featureName] || !validActiveContracts.length) {
        return configFeatureEnabled
      } else {
        contractFeatureEnabled = validActiveContracts.some(contract =>
        contract.contractNumber.split('-')[1].startsWith(features[featureName]))
      }
      return configFeatureEnabled && contractFeatureEnabled
  }

  const features = {
      loyaltyEnabled:'MV',
      topDealsEnabled: 'MV',
      digitalFormsEnabled: 'MV',
      ocInspectionEnabled:'MV',
      rentContractOverviewEnabled:'MV',
      pageRentAccountBalanceVisibleTo:'MV',
      rentContractDocumentsEnabled:'MV',
      pageOcCalculationsVisibleTo:'MV',
      rentCertificatePostalEnabled:'MV',
      rentCertificatePaidEnabled:'MV',
      consultationsBookingEnabled:'MV',
      condoContractDocumentsEnabled:'W',
      pageCondoAccountBalanceVisibleTo:'W',
      condoContractOverviewEnabled:'W',
      condoReceiptInspectionFeaturesEnabled:'W',
      pageCondoAccountBalancesVisibleTo:'W',
      pageCondoInvoicesVisibleTo:'W',
      pageCondoIncomeVisibleTo:'W',
      financialPlansAndCondoStatementsEnabled:'W',
      faqEnabled: 'MV',
      lettersEnabled: 'MV',
      lettersEnabledForCondo: 'W',
      vouchersEnabled: 'MV',
      vouchersPhaseTwoEnabled: 'MV',
    }